
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Pharmacological_treatment_of_type_2_diabetes",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/Pharmacological_treatment_of_type_2_diabetes.vue